// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[v-cloak]{display:none}body,html{margin:0;padding:0;height:100%}*{box-sizing:border-box}a{text-decoration:none}.description-box,.description-box img{width:100%}", ""]);
// Exports
module.exports = exports;
